import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link, useNavigate } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import classNames from "classnames";
import { Select2Data } from "../../../utils/common";
import Select from "react-select";
import Header from "../../Header/Header";
import "./Add.css"
library.add(fas);

const AddOffCanvance = (props) => {
  const { postData, getData } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });


  const navigate = useNavigate()

  const {
    register, control,
    handleSubmit, watch,
    formState: { errors },
  } = useForm();


  const { fields, append, remove } = useFieldArray({
    control,
    name: "cabs",
  });
  const onSubmit = async (data) => {
    try {
      console.log(data);
      // return;
      const response = await postData(`/masters/location`, data);
      console.log(response);
      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
        setTimeout(() => {
          setShowModal(0);
          navigate(-1);
        }, 1000);
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }

    } catch (error) {
      console.log(error);
    }
  };

  const [cabType, setCabType] = useState([]);

  const GetAllCabType = async () => {
    const response = await getData("/all-cab-type");

    if (response?.success) {
      setCabType(await Select2Data(response?.data, "cab_type_id"));
    }
  };



  useEffect(() => {
    GetAllCabType();
  }, []);

  const selectedCabs = watch("cabs") || [];
  const name = watch("name");

  return (
    <>
      {/* <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="edit-modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Location
          </Modal.Title>
        </Modal.Header>
        <Modal.Body> */}
      <Header title={"Add Location"} link={"/masters/location"} />
      <div className="add-form">
        <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
          <Row className="justify-content-center">
            <Col md={12}>
              <div className="main-form-section mt-3">
                <Form.Group>
                  <div className="">
                    <Form.Label>Name</Form.Label>
                  </div>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Name"
                      className={classNames("", {
                        "is-invalid": errors?.name,
                      })}
                      {...register("name", {
                        required: "Name is required",
                        validate: (value) =>
                          value.length <= 200 ||
                          "Data must be 200 characters or less",
                      })}
                    />
                  </InputGroup>
                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </Form.Group>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <button
                type="button"
                className="btn btn-success mt-3"
                disabled={!name}
                onClick={() =>
                  append({
                    cab_type_id: null,
                    drop_amount: "",
                    return_amount: "",
                  })
                }
              >
                + Add Cab Type
              </button>
            </Col>
          </Row>
          {fields.map((item, index) => {
            const dropAmount = watch(`cabs.${index}.drop_amount`);
            const returnAmount = watch(`cabs.${index}.return_amount`);

            const selectedValues = selectedCabs
              ?.map((cab, i) => (i !== index ? cab?.cab_type_id?.value : null))
              .filter(Boolean);

            const filteredOptions = cabType.map((opt) => ({
              ...opt,
              isDisabled: selectedValues.includes(opt.value),
            }));

            const prevRow = selectedCabs[index - 1];

            const disableReturn =
              prevRow?.drop_amount && !prevRow?.return_amount;

            const disableDrop =
              prevRow?.return_amount && !prevRow?.drop_amount;


            return (
              <Row key={item.id} className="mt-3">

                <Col md={4}>
                  <Controller
                    name={`cabs.${index}.cab_type_id`}
                    control={control}
                    rules={{ required: "Select Cab type" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={filteredOptions}
                        placeholder="Select Cab"
                      />
                    )}
                  />
                  {errors?.cabs?.[index]?.cab_type_id && (
                    <span className="text-danger">
                      {errors.cabs[index].cab_type_id.message}
                    </span>
                  )}
                </Col>

                <Col md={3}>
                  <Form.Control
                    placeholder="Drop Amount"
                    disabled={disableDrop}

                    {...register(`cabs.${index}.drop_amount`, {
                      validate: (value) => {
                        // if (!value && !returnAmount) {
                        //   return "Either Drop Amount or Return Amount is required";
                        // }
                        if (value && Number(value) < 1) {
                          return "Drop Amount cannot be less than 1";
                        }
                        return true;
                      },
                    })}
                    onKeyDown={(e) => {
                      if (
                        e.key === "-" || // Prevent negative sign
                        e.key === "+" || // Prevent plus sign
                        e.key === "e" || // Prevent scientific notation
                        e.key === "E" || // Prevent scientific notation
                        e.key === "." || // Prevent decimal point (if only integers allowed)
                        (isNaN(Number(e.key)) &&
                          e.key !== "Backspace" &&
                          e.key !== "Tab") // Allow only numbers, Backspace, and Tab
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />
                  {errors?.cabs?.[index]?.drop_amount && (
                    <span className="text-danger">
                      {errors.cabs[index].drop_amount.message}
                    </span>
                  )}
                </Col>

                <Col md={3}>
                  <Form.Control
                    placeholder="Return Amount"
                    disabled={disableReturn}

                    {...register(`cabs.${index}.return_amount`, {
                      validate: (value) => {
                        if (!value) {
                          return "Return Amount is required";
                        }
                        if (value && Number(value) < 1) {
                          return "Return Amount cannot be less than 1";
                        }
                        return true;
                      },
                    })}

                    onKeyDown={(e) => {
                      if (
                        e.key === "-" || // Prevent negative sign
                        e.key === "+" || // Prevent plus sign
                        e.key === "e" || // Prevent scientific notation
                        e.key === "E" || // Prevent scientific notation
                        e.key === "." || // Prevent decimal point (if only integers allowed)
                        (isNaN(Number(e.key)) &&
                          e.key !== "Backspace" &&
                          e.key !== "Tab") // Allow only numbers, Backspace, and Tab
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />
                  {errors?.cabs?.[index]?.return_amount && (
                    <span className="text-danger">
                      {errors.cabs[index].return_amount.message}
                    </span>
                  )}
                </Col>
                <Col md={2}>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => remove(index)}
                  >
                    Remove
                  </button>
                </Col>

              </Row>
            );
          })}

          <Row className="mt-5 pb-3">
            <div className="d-flex justify-content-center">
              <Link>
                <CancelButton
                  name={"cancel"}
                  handleClose={() => navigate(-1)}
                />
              </Link>

              <SaveButton
                name={"save"}
                handleSubmit={handleSubmit(onSubmit)}
              />
            </div>
          </Row>

        </Form>
      </div>
      {/* </Modal.Body>
      </Modal> */}

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
